import { restApi } from '../../../services/api';

interface CreateFailStoreConnectionLogPayload {
  userId: string;
  brandId: string;
  storeId: string;
}

export const createFailStoreConnectionLog = ({
  brandId,
  storeId,
  userId,
}: CreateFailStoreConnectionLogPayload) =>
  restApi.post('fail-store-connections', {
    userId,
    brandId,
    storeId,
  });
